var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObligationToYieldCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EA0029;}\r\n\t.st1{fill:#FFCD00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,8) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,19.8l28.7,49.7c1,1.7,2.8,2.8,4.8,2.8c2,0,3.8-1.1,4.8-2.8l28.7-49.7c1-1.7,1-3.8,0-5.5 c-1-1.7-2.8-2.8-4.8-2.8H11.3c-2,0-3.8,1.1-4.8,2.8C5.5,16,5.5,18.1,6.5,19.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12.8,17.9 40,65 67.2,17.9 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObligationToYieldCanvas);
export default __webpack_public_path__ + "static/media/obligation-to-yield-canvas.ac596093038f669acc2544ec1f1144f5.svg";
export { ForwardRef as ReactComponent };